import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskScheduleUpdated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskScheduleUpdated_ActivityLogFragment;
}

const ActivityLogTaskScheduleUpdated: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.updatedSchedule"
    />
  );
};

ActivityLogTaskScheduleUpdated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskScheduleUpdated_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskScheduleUpdated;
